export default {
  headerVisible: true,
  isCustomView: false,
  sidebarVisible: true,
  size: {},
  drawerBreakpoint: 600,
  drawerOverlay: true,
  drawerBehavior: 'default',
  leftDrawerSize: 0,
  sidebarOpen: false,
  printing: false,
  dialogs: [],
  toolsControlVisible: true,
  mapControlled: false,
  deactivateClick: false,
  showFloatingSearchBar: false
}
